export default __webpack_public_path__ + "static/media/5.e5f429a4.png";